import { useModalResponsiveTableRequestContext } from '@/components/DashboardCard/components/ModalResponsiveTableRequestV2';
import { maskItem } from '@/components/DashboardCard/utils/maskItem';
import React from 'react';
import { FiExternalLink } from 'react-icons/fi';

import { CellTypeProps } from '../../interfaces';
import { BadgeIcon, Content, Text } from './styles';

const Badge: React.FC<CellTypeProps> = ({
  extraValue,
  backgroundColor,
  badgeBackgroundColor,
  children,
  color,
  value,
  fontWeight,
  fontSize,
  textMargin,
  maskValue,
  justifyBadge,
  modalSubComponent,
}) => {
  const { handleOpen } = useModalResponsiveTableRequestContext();

  if (modalSubComponent) {
    return (
      <Content
        style={{ backgroundColor: badgeBackgroundColor ?? 'transparent' }}
        justifyBadge={
          justifyBadge || (value || extraValue ? 'normal' : 'center')
        }
        $clickable
        onClick={() => {
          if (modalSubComponent) handleOpen(modalSubComponent);
        }}
      >
        <BadgeIcon backgroundColor={backgroundColor} />
        {(value || extraValue) && (
          <Text
            color={color}
            fontWeight={fontWeight}
            fontSize={fontSize}
            textMargin={textMargin}
          >
            {maskValue ? maskItem(maskValue, value) : value}
            {children !== '-' && extraValue}
          </Text>
        )}
        <FiExternalLink />
      </Content>
    );
  }

  return (
    <Content
      style={{ backgroundColor: badgeBackgroundColor ?? 'transparent' }}
      justifyBadge={justifyBadge || (value || extraValue ? 'normal' : 'center')}
    >
      <BadgeIcon backgroundColor={backgroundColor} />
      {(value || extraValue) && (
        <Text
          color={color}
          fontWeight={fontWeight}
          fontSize={fontSize}
          textMargin={textMargin}
        >
          {maskValue ? maskItem(maskValue, value) : value}
          {children !== '-' && extraValue}
        </Text>
      )}
    </Content>
  );
};

export default Badge;
